// Everyone the customer is bringing: players/students + supporters + their own
// staff/teachers. `participants` on a request is players only, so use this
// wherever a headcount is shown as "pax"/"travellers" rather than for pricing.
export function totalTravellers(r) {
  if (!r) return 0;
  return (Number(r.participants) || 0)
    + (Number(r.supportersMale) || 0) + (Number(r.supportersFemale) || 0)
    + (Number(r.customerStaff) || 0);
}
